import { create } from "zustand";
import {
  type FileVersionData,
  getFileVersionByVersionId,
} from "@/services/files";

export const FileLatestVersion = "latest_version";
export type VersionId = string;

export interface FileVersionStoreState {
  fileVersion: FileVersionData | null;
  fileVersionId: VersionId;
  setFileVersionId: (fileVersionId: VersionId) => void;
  loading: boolean;
  error: string | null;
  fetch: (fileId: number, versionId: number) => Promise<void>;
  reset: () => void;
}

export const useFileVersionStore = create<FileVersionStoreState>()((set) => ({
  loading: false,
  fileVersion: null,
  error: null,
  fileVersionId: FileLatestVersion,
  fetch: async (fileId: number, versionId: number): Promise<void> => {
    try {
      set({ loading: true, error: null, fileVersion: null });
      const data = await getFileVersionByVersionId(fileId, versionId);
      set({ fileVersion: data });
    } catch {
      set({ error: "Error to get file version" });
    } finally {
      set({ loading: false });
    }
  },
  setFileVersionId: (fileVersionId: VersionId): void => {
    set({ fileVersionId });
  },
  reset: (): void => {
    set({ fileVersion: null, fileVersionId: FileLatestVersion });
  },
}));
